// ── <WebGLBoundary /> — fail-open error boundary for 3D content.
// If the MiniGlobe (three-globe / WebGL) throws AT ANY POINT during
// render — GPU context lost, texture blocked by ad-blocker, memory
// pressure on low-end Android — we swap the entire subtree for the
// fallback tree instead of showing a blank white screen. Reports the
// crash via analytics.trackEvent so we can size the affected cohort.
import React from "react";
import { trackEvent } from "@/lib/analytics";

export default class WebGLBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { crashed: false };
  }
  static getDerivedStateFromError() {
    return { crashed: true };
  }
  componentDidCatch(err, info) {
    try {
      trackEvent("webgl_render_crashed", {
        message: String(err?.message || err).slice(0, 120),
        stack: String(info?.componentStack || "").slice(0, 200),
      });
    } catch { /* ignore */ }
    // Also fire the same event we listen to elsewhere for auto-2D.
    try {
      window.dispatchEvent(new CustomEvent("we-globe-webgl-crashed"));
    } catch { /* ignore */ }
  }
  render() {
    if (this.state.crashed) return this.props.fallback || null;
    return this.props.children;
  }
}
